<template>
  <div class="shippingAddress">
    <address-list
      :addressList="addressList"
      :isSelection="isSelection"
      @addressDidTap="actionAddressDidTap"
      @editAddress="editAddress"
    ></address-list>
    <div :class="['tool-bar', isSelection ? 'selectionBox' : '']">
      <van-button type="info" block @click="addAddress">{{
        $t.address.addAddress
      }}</van-button>
    </div>
    <placeholder v-if="isPlaceholder"></placeholder>
  </div>
</template>
<script>
import AddressList from "./components/AddressList";
import Placeholder from "@/components/common/Placeholder";
import Vue from "vue";
import { Button } from "vant";
Vue.use(Button);

export default {
  name: "ShippingAddress",
  props: {
    isSelection: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    AddressList,
    Placeholder,
  },
  data() {
    return {
      addressList: [],
      isPlaceholder: false,
    };
  },
  mounted() {
    this.getCustomerReceivingList();
  },
  methods: {
    getCustomerReceivingList() {
      return new Promise((resolve, reject) => {
        this.$commonMethod.showLoading();
        let param = {};
        this.$api.address
          .getCustomerReceivingList(param)
          .then((res) => {
            const data = res.data;
            this.addressList = data;
            if (data == null || data === "" || data.length === 0) {
              this.isPlaceholder = true;
            } else {
              this.isPlaceholder = false;
            }
            this.$commonMethod.hideLoading();
            resolve(true);
          })
          .catch((error) => {
            this.$commonMethod.hideLoading();
            this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
              msg: error.message,
            });
            reject();
          });
      });
    },
    addAddress() {
      if (this.isSelection) {
        this.$emit("addAddress");
      } else {
        this.$commonEnv.commonAction(this.$commonEnv.actionType.routerPush, {
          isParams: false,
          path: "editAddress",
          name: "editAddress",
          query: [],
        });
      }
    },
    actionAddressDidTap(address) {
      if (this.isSelection) {
        this.$emit("selectedAddress", address);
      } else {
        this.$commonEnv.commonAction(this.$commonEnv.actionType.routerPush, {
          isParams: true,
          path: `editAddress/${address.CRId}`,
          name: "EditAddress",
          query: [
            {
              name: "Address",
              value: address,
            },
          ],
        });
      }
    },
    editAddress(address) {
      if (this.isSelection) {
        this.$emit("editAddress", address);
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.shippingAddress {
  width: 100%;
  .selectionBox {
    position: absolute !important;
    bottom: calc(0px + env(safe-area-inset-bottom)) !important;
  }
  .tool-bar {
    box-sizing: border-box;
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100%;
    background-color: white;
    z-index: 100;
    justify-content: space-between;
    padding-bottom: env(safe-area-inset-bottom);
    .van-button {
      border-radius: 0px;
    }
  }
}
</style>
